import { ResponseDTO } from './response-dto';
import { UserContextRoleScopeDTO } from './user-context-role-scope-dto';
import { UserContextRoleScopeFieldDTO } from './user-context-role-scope-field-dto';

export interface ReadContextRoleScopeProfilesResponseDTO extends ResponseDTO {
    scopeFields?: UserContextRoleScopeFieldDTO[];
    scopes?: UserContextRoleScopeDTO[];
}
